import { api } from "../ConsumeApiController";
import CustomerRoutes from "../../apiRoutes/CustomerRoutes";

export const getMyBookings = async (group = 'upcoming', page = 1) => {
    try {
        const response = await api.get(CustomerRoutes.Bookings.MyBookings(group,page));
        const payload = response.data; // { data, meta, links }
        
        return {
            success: true,
            data: payload.data,
            meta: payload.meta
        };
    } catch (error) {
        console.error("Error fetching bookings:", error);
        return { success: false, data: [], meta: null };
    }
};